<template>

    <div>

        <div class="app-wrap" :class="{'show-sidebar': showSidebar}">

            <div v-if="showSidebar"
                 class="app-left"
                 :style="(windowWidth > 900)? {width: sidebar.collapsed ? '56px' : '320px'} : {width: sidebar.collapsed ? '56px' : '320px'}">
                <app-sidebar :collapsed="sidebar.collapsed"/>
            </div>

            <div class="app-right"
                 :style="showSidebar && (windowWidth > 900)? {'margin-left':  sidebar.collapsed ? '56px' : '320px'} : {'margin-left':  showSidebar && sidebar.collapsed ? '56px' : ''}">

                <template v-if="account_status?.type === 'trial' || account_status?.type === 'org:trial'">
                    <div class="bg-warning text-center px-2 py-1">
                        Your {{ account_status.type === 'org:trial' ? 'organizational' : '' }} trial will expire in
                        <strong>{{ account_status.limit }}</strong> day{{ account_status.limit > 1 ? 's' : '' }}.
                        After which, you account will automatically convert into a <strong>free</strong> account.
                    </div>
                </template>

                <app-nav v-if="showNavbar" :has-sidebar="showSidebar" :mainPage="mainPage">
                    <template #navbar-left v-if="$slots['navbar-left']">
                        <slot name="navbar-left"></slot>
                    </template>
                </app-nav>

                <main class="py-2">

                    <div class="toolbox-area" v-show="$slots.toolbox">
                        <slot name="toolbox"></slot>
                    </div>

                    <div class="main-area">

                        <jet-banner />
                        <slot></slot>
                    </div>

                </main>

            </div>
        </div>

    </div>
</template>

<script>
import AppSidebar from "@/Components/AppSidebar";
import AppNav from "@/Components/AppNav";
import JetBanner from "@/Jetstream/Banner";
import {mapState, mapMutations} from "vuex";
import jQuery from "jquery";
import VueCookies from 'vue-cookies';

export default {
    name: "AdminLayout",
    components: {AppNav, AppSidebar, JetBanner},
    props: {
        showSidebar: {
            type: Boolean,
            default: true,
        },
        showNavbar: {
            type: Boolean,
            default: true,
        },
        mainPage: {
            type: String,
            default: ""
        }
    },

    data(){
        return {
            windowWidth: 0,
            scrollPosition: 0
        }
    },

    computed: {
        ...mapState(['sidebar', 'toolbox']),

        account_status(){
            if( this.current_user.derived_account_type === 'free' ){
                return {type: 'free'};
            }

            if( this.current_user.account_type === 'paid' ){
                if( ! this.current_user.trial_expire_at ){
                    return {type: 'paid'};
                }
            }

            if( this.current_user.organizations?.length ){
                const org = this.current_user.organizations[0];
                if( org.account_type === 'paid' ){
                    if( org.trial_expire_at ){
                        if( this.current_user.trial_expires_in === null || org.trial_expires_in > this.current_user.trial_expires_in ){
                            if( org.trial_expires_in >= 0 ){
                                return {type: 'org:trial', limit: org.trial_expires_in};
                            }
                            return {type: 'org:trial:expired'};
                        }
                    }else{
                        return {type: 'org:paid'};
                    }
                }
            }

            if( this.current_user.trial_expire_at ){
                if( this.current_user.trial_expires_in >= 0 ){
                    return {type: 'trial', limit: this.current_user.trial_expires_in};
                }
                return {type: 'trial:expired'};
            }

        },

    },

    methods:{
        widthChange(){
            this.windowWidth = window.innerWidth;
        }
    },

    watch:{
        'sidebar.collapsed'(newVal){
            if(this.windowWidth < 1200){
                $cookies.set("Sidebar", newVal)
            }
        }
    },

    beforeMount(){
        window.removeEventListener('resize', this.widthChange)
    },

    mounted() {

        // Set the theme.
        jQuery(($) => {
            if( this.theme_background ){
                $('html')
                    .css({'background-image': `url(${this.theme_background})`})
                    .addClass('has-background');
            }
        });

        this.windowWidth = window.innerWidth;

        if(this.windowWidth < 1200 && !$cookies.get("Sidebar")){
            this.$store.state.sidebar.collapsed = true;
        }

        else if(this.windowWidth < 1200 && $cookies.get("Sidebar")){
            var current = ($cookies.get("Sidebar") === 'true');
            this.$store.state.sidebar.collapsed = current;
        }

        window.addEventListener('resize', this.widthChange)

    }

}
</script>

<style lang="scss" scoped>
.app-wrap {
    margin: auto;
    overflow: visible;

    &.show-sidebar{
        width: auto;
        max-width: none;
    }

    .app-left {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        z-index: 30;
    }
}

@media (max-width: 768px) {
    .app-wrap {
        width: 95% !important;
    }
}

@media (min-width: 650px) and (max-width: 1199px){
    .app-wrap {

        .app-left {
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            z-index: 9999 + 51;
            background: rgba(255, 255, 255, 0.7);
            backdrop-filter: blur(5px);
        }

        .app-right{
            position: relative;
        }
    }
}

main{
    display: flex;
}

.toolbox-area{
    position: sticky;
    top: 80.19px;
    height: calc(100vh - 90px);
}

.main-area{
    flex-grow: 1;
}

</style>
